import * as React from 'react';

export interface ReactLinkData {
    id?: string,
    href?: string,
    text: string,
    style?: {},
    css?: string,
    row?: {},
    rowIndex?: number,
    onClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, rowIndex: number) => void,
    disabled?: boolean,
    disableID?: string,
    tabIndex?: null,
    title?: string,
    stopPropagationOnClick?: boolean,
}

export interface ReactLinkState {
    disabled: boolean,
}

export class ReactLink extends React.Component<ReactLinkData>{
    constructor(props: ReactLinkData) {
        super(props);

        this.state = {disabled: props.disabled};

        // Binding is necessary to allow these functions access to the State data
        this.handleClick = this.handleClick.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactLinkData) {
        this.setState({
            disabled: props.disabled
        });
    }

    handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
        if(null != this.props.onClick && !(this.state as ReactLinkState).disabled) {
            this.props.onClick(this.props.row, event.shiftKey, event.ctrlKey, this.props.rowIndex);
        }

        if(null != this.props.stopPropagationOnClick && this.props.stopPropagationOnClick) {
            event.stopPropagation();
        }
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    getLink() {
        if(this.props.title) {
            return <a id={this.props.id} tabIndex={this.props.tabIndex} href={this.props.href} className={this.props.css} style={this.props.style} onClick={this.handleClick} title={this.props.title}>{this.props.text}</a>
        } else {
            return <a id={this.props.id} tabIndex={this.props.tabIndex} href={this.props.href} className={this.props.css} style={this.props.style} onClick={this.handleClick}>{this.props.text}</a>
        }
    }

    render() {
        return  <React.Fragment>
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactLinkState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE BUTTON
                </td>
            </tr></table>
            }
            {this.getLink()}
        </React.Fragment>;
    }
}
